import type { dashboardCanvasRendererProps } from '@/components/dashboard/DashboardCanvas';
import { dashboardT } from '@/lib/messages';
import { DashboardPerformanceChart } from '../../../dashboard/components/DashboardPerformanceChart';
import { integrationPerformanceSeries } from './reportRequest';
import type { IntegrationDashboardRuntime } from './widgetRuntime';
import { IntegrationDashboardWidgetType, type IntegrationDashboardWidget } from './widgetModel';

export function IntegrationPerformanceRenderer({
  widget,
  runtime,
}: dashboardCanvasRendererProps<IntegrationDashboardWidget, IntegrationDashboardRuntime>) {
  if (widget.type !== IntegrationDashboardWidgetType.PerformanceChart) return null;
  const range = runtime.rangesByWidgetId.get(widget.id);
  if (!range) return null;
  const query = runtime.queriesByRangeKey.get(runtime.rangeKey(range));
  return (
    <DashboardPerformanceChart
      title={widget.title ?? dashboardT('integrations.dashboard.performance')}
      ariaLabel={dashboardT('integrations.dashboard.performanceAriaLabel')}
      range={range}
      metricSeries={integrationPerformanceSeries(
        query?.request,
        query?.current.data,
        widget.metrics,
      )}
      loading={!query || query.current.isLoading}
      error={Boolean(query?.current.isError)}
      actions={[]}
    />
  );
}
